import { Label } from '@cian/ui-kit';

import { type FC, type MouseEvent as ReactMouseEvent } from 'react';

import { GetOnlineButton } from '../GetOnlineButton';

interface ITitleColumnRightProps {
  isBlackFridayPromo: boolean | undefined;
  isGetOnlineButtonAvailable: boolean;
  mortgagePartnerLink: string;
  onGetOnlineButtonClick: (event: ReactMouseEvent) => void;
}

export const TitleColumnRight: FC<ITitleColumnRightProps> = ({
  isBlackFridayPromo,
  isGetOnlineButtonAvailable,
  mortgagePartnerLink,
  onGetOnlineButtonClick,
}) => {
  if (isBlackFridayPromo) {
    return (
      <Label background="accent-main-secondary" color="accent-main-primary" data-testid="MortgageOfferBlackFridayLabel">
        Чёрная пятница
      </Label>
    );
  }

  if (isGetOnlineButtonAvailable) {
    return <GetOnlineButton href={mortgagePartnerLink} onClick={onGetOnlineButtonClick} />;
  }

  return null;
};
